import type { ReactNode } from 'react';

import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

// :: Hooks
import useDarkMode from '../hooks/useDarkMode';
import { useDowngradeModals } from './hooks/useDowngradeModals';

// :: Images
import { FourSquaresColor, FourSquaresColorWhite } from '../images/shapes';

import Structure from './Structure';

const testId = 'layout';

interface LayoutSlimProps {
  /**
   * Children elements to be rendered
   */
  children?: ReactNode;
  /**
   * Test id for layout
   */
  testId?: string;
}

const LayoutSlim = ({ children }: LayoutSlimProps) => {
  const { t } = useTranslation();
  const [darkMode] = useDarkMode();
  const checkDowngradeNotices = useDowngradeModals(testId);

  useEffect(() => {
    checkDowngradeNotices();
  }, [checkDowngradeNotices]);

  const SIDEBAR_MENU_ITEMS = useMemo(
    () => [
      {
        key: 'dashboard',
        icon: darkMode ? (
          <FourSquaresColorWhite className="w-6 min-w-6" />
        ) : (
          <FourSquaresColor className="w-6 min-w-6" />
        ),
        title: t('Global.Dashboard'),
        link: `/`,
      },
    ],
    [darkMode, t],
  );

  return (
    <Structure sidebarMenuItems={SIDEBAR_MENU_ITEMS} testId={testId}>
      {children ? children : <Outlet />}
    </Structure>
  );
};

export default LayoutSlim;
